import { Component } from '@angular/core';
import {HeroEspecialidadesComponent} from "../especialidades-person/hero-especialidades/hero-especialidades.component";
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {TopBarComponent} from "../../top-bar/top-bar.component";
import {HeroMoviLinkComponent} from "./hero-pages/hero-movi-link.component";
import {ServicesMoviLinkComponent} from "./services-movi-link/services-movi-link.component";
import {HowToApplyServiceComponent} from "./how-to-apply-service/how-to-apply-service.component";
import {AmbulanceComponent} from "./ambulance/ambulance.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";

@Component({
  selector: 'app-movi-link',
  standalone: true,
  imports: [
    HeroEspecialidadesComponent,
    NavBarComponent,
    TopBarComponent,
    HeroMoviLinkComponent,
    ServicesMoviLinkComponent,
    HowToApplyServiceComponent,
    AmbulanceComponent,
    FooterPersonaComponent,
    FloatButtonComponent
  ],
  templateUrl: './movi-link.component.html',
  styleUrl: './movi-link.component.css'
})
export class MoviLinkComponent {

}
